<template lang="html">
  <div>
    <toolBar></toolBar>
      <b-container class="single-item-container" fluid>
        <b-row v-if="getSearchTerm">
          <b-col id="singleImageLeft" v-on:click="prevPic" v-show="getCurrentIndex > 0">
            <i class="material-icons">keyboard_arrow_left</i>
          </b-col>
          <b-col id="singleImageRight" v-on:click="nextPic" v-show="getCurrentIndex < getMatchedImages.length - 1">
            <i class="material-icons">keyboard_arrow_right</i>
          </b-col>
        </b-row>
        <img v-bind:src="getSingleImageSrc" alt="" style="width: 100%;" v-touch:tap="touched" v-touch:swipe.left="nextPic" v-touch:swipe.right="prevPic" v-touch-class="'active-touch'" id="singleImage" v-show="!loading">
        <img v-bind:src="blurredImage" alt="" id="blurred-image-loading" style="width: 100%;" v-show="loading">
        <div style="padding-top:50px;"> </div>
        <people :people="getSingleImage._source.people"></people>
        <tagChips :keywords="getSingleImage._source.keywords"></tagChips>
        <colors :colors="getSingleImage._source.colors"></colors>
        <dateTime :dateTime="getSingleImage._source.exif.created"></dateTime>
        <location :loc="getSingleImage._source.location" :places="getSingleImage._source.places"></location>
      </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { store } from '../store/store'
import singleItemMap from '../components/singleItemMap'
import { fullImage, thumbnailImage } from '../images.config.inc.js'

export default {
  data(){
    return{
      singleItem: '',
      searchTerm: '',
      displayIcon: 'local_offer',
      loading: true,
      blurredImage: ``
    }
  },
  methods: {
    ...mapActions([
      'retrieveSingleItemByParams',
      'selectSingleItem'
    ]),
    touched(e){
      console.log('touched', e);
    },
    nextPic(){
      if(this.getSearchTerm && this.getCurrentIndex < this.getMatchedImages.length - 1){
        const nextImage = this.getMatchedImages[this.getCurrentIndex + 1];
        const that = this;
        this.loading = true;
        this.blurredImage = this.getCachedImages[1];
        store.dispatch('selectSingleItem', {
          imageSrc: `${fullImage}${nextImage._source.resource_id}.jpg`,
          image: nextImage,
          currentIndex: this.getCurrentIndex + 1
        }).then(() => {
            setTimeout(() => {
              that.$router.push(`/image/${nextImage._source.resource_id}`);
              that.loading = false;
            },800)
        })
      }
    },
    prevPic(){
      if(this.getSearchTerm && this.getCurrentIndex > 0){
        const prevImage = this.getMatchedImages[this.getCurrentIndex - 1]
        const that = this;
        this.loading = true;
        this.blurredImage = this.getCachedImages[0];
        store.dispatch('selectSingleItem', {
          imageSrc: `${fullImage}${prevImage._source.resource_id}.jpg`,
          image: prevImage,
          currentIndex: this.getCurrentIndex - 1
        }).then(() => {
            setTimeout(() => {
              that.$router.push({name: 'singleItem', params: {id: prevImage._source.resource_id} })
              that.loading = false;
            },800)
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getSingleImageSrc',
      'getMatchedImages',
      'getCurrentIndex',
      'getSingleImage',
      'getSearchTerm',
      'getCachedImages'
    ])
  },
  components:{
    'singleItemMap': singleItemMap
  },
  created(){
    window.scrollTo(0,0);
    this.loading = false;
  },
  beforeRouteEnter( to, from, next) {
    if(!from.name || from.name.name === 'demodrilldown'){
      store.dispatch('retrieveSingleItemByParams', to.params.id)
      .then((data) => {
        next();
      })
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next){
    if(from.name === 'singleItem') {
      store.dispatch('retrieveSingleItemByParams', to.params.id)
      .then((data) => {
        store.dispatch('retrieveNextItems')
        window.scrollTo(0,0);
        next();
      })
    } else {
      next();
    }
    window.scrollTo(0,0);
    next();
  },
  updated(){
    document.getElementById('blurred-image-loading').style.height = `${this.getSingleImage._source.height / (this.getSingleImage._source.width / 950)}px`;
  }
}
</script>

<style lang="css" scoped>
  .single-item-container {
    margin-top: 6em;
    margin-bottom: 3em;
  }

  img {
    margin-bottom: 2em;
  }
  .icon img {
  	min-width:1em;
  	max-width:1.5em;
  	float:right;
	}

  #singleImageLeft, #singleImageRight {
    display: none;
  }

  .active-touch {
    border: 3px solid yellow;
    opacity: 0.8;
  }

  #blurred-image-loading {

  }


  @media only screen  and (min-width : 1224px) {
    .single-item-container {
      max-width:1200px;
    }

    #singleImageLeft, #singleImageRight {
      opacity: 0.7;
      display: inline-block;
      position: absolute;
      margin: 0;
      padding: 0;
      cursor: pointer;
      width: 40%;
      height: 90%;
    }

    #singleImageRight {
      right: 2%;
    }

    #singleImageRight > i {
      position: fixed;
      right:-0.1em;
      top: 3em;
      font-size: 120px;
    }

    #singleImageLeft {
      left: 2%;
    }

    #singleImageLeft > i {
      position: fixed;
      left: -0.1em;
      top: 3em;
      font-size: 120px;
    }

    #singleImageLeft:hover, #singleImageRight:hover {
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/singleItem.vue